import React ,{useEffect} from 'react';
import AOS from 'aos';
import Header from '../Components/Shared/Header/Header';
import Banner from '../Components/Pages/Pricing/Banner';
import PricingTabs from '../Components/Pages/Pricing/PricingTabs';
import { images } from '../Components/Pages/Home/data';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import InnovativePart from '../Components/Pages/Home/Innovative';
import Features from '../Components/Pages/Home/Features';
import Blogs from '../Components/Shared/BlogsSection/Blogs';
import Slider from '../Components/Shared/LogoSlider/Slider';
import FAQ from '../Components/Shared/FAQ/FAQ';
function Pricing(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header/>
        <Banner />
        <PricingTabs />
        <InnovativePart />
        <Features />
        <FAQ />
        <Slider list={images}/>
        <Blogs />
        <Start/>
        <Footer />
        </>
    )
};
export default Pricing ;